import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LoginService } from '../shared/services/login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false,
})
export class LoginComponent implements OnInit, OnDestroy {
  public loginFormGroup!: FormGroup;
  public loggingIn = false;
  private redirectUrl!: string;
  passwordFieldType: string = 'password';
  private loginSub: Subscription | null = null;

  constructor(
    public router: Router,
    private fb: FormBuilder,
    private login: LoginService,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
  ) {
    this.loginFormGroup = this.fb.group({
      username: new FormControl(null, Validators.required),
      password: new FormControl(null, Validators.required),
      rememberMe: [false],
    });
  }

  ngOnInit() {
    // default to the products listing when no specific redirect was provided
    this.redirectUrl = this.route.snapshot.queryParamMap.get('redirectUrl') || '/products';
    if (this.login.isTokenValid()) {
      this.router.navigate([this.redirectUrl], { replaceUrl: true });
    }
  }

  public logIn(): void {
    if (this.loginFormGroup.invalid || this.loggingIn) {
      return;
    }

    this.loggingIn = true;
    this.loginSub = this.login
      .login(this.loginFormGroup.controls['username'].value, this.loginFormGroup.controls['password'].value)
      .subscribe({
        next: (res) => {
          if (res.authentication.token) {
            localStorage.setItem('token', res.authentication.token);
          }
          localStorage.setItem('expires_at', res.authentication.validTo.toString());
          this.login.setUser(res.feUser);
          this.loggingIn = false;
          this.router.navigateByUrl(this.redirectUrl);
        },
        error: () => {
          this.loggingIn = false;
          this.loginSub = null;
          const errorMsg = 'Invalid username or password';
          this.showErrorNotification(errorMsg);
        },
      });
  }

  ngOnDestroy(): void {
    this.loginSub?.unsubscribe();
  }

  public get usernameField() {
    return this.loginFormGroup.get('username');
  }

  public get passwordField() {
    return this.loginFormGroup.get('password');
  }

  togglePasswordVisibility() {
    this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
  }

  private showErrorNotification(message: string) {
    this.snackBar.open(message, 'Close', {
      duration: 3000,
    });
  }
}
